import { Button } from '@hqo/react-components-library/dist/atoms/button';
import styled from 'styled-components';

export const StyledButton = styled(Button)<{ isBookButton?: boolean }>`
  width: ${({ isBookButton }) => (isBookButton ? '66px' : '138px')};
  padding: 4px 10px;
`;
